import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./jeconDialog.css";

const ReopenFlangeDialog = ({ open, onClose, onSubmit, loading }) => {
  const [remark, setRemark] = useState("");

  const handleSubmit = () => {
    if (!remark.trim()) return;
    onSubmit(remark);
    setRemark(""); // reset after submit
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: "jecon-dialog" }}
    >
      <DialogTitle sx={{ position: "relative" }}>
        Reopen Flange
        <IconButton
          onClick={onClose}
          disabled={loading}
          sx={{ position: "absolute", right: 8, top: 8, color: "#667085" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            p: 1.5,
            mb: 2,
            borderRadius: 1,
            bgcolor: "#fff5f5",
            border: "1px solid #f0d5d5",
          }}
        >
          <Typography fontSize="0.85rem" sx={{ color: "#7f1d1d" }}>
            Provide a reason to reopen this flange !
          </Typography>
        </Box>

        <textarea
          className="remark-input"
          placeholder="Type your remark..."
          rows={3}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          disabled={loading}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          sx={{
            borderColor: "#d3a3a3",
            color: "#7f1d1d",
            "&:hover": {
              borderColor: "#b71c1c",
              backgroundColor: "#fff5f5",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={loading}
          variant="contained"
          sx={{
            backgroundColor: "#b71c1c",
            "&:hover": { backgroundColor: "#9f1919" },
          }}
        >
          {loading ? "Submitting..." : "Reopen"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReopenFlangeDialog;
